class BuyBonusButtonHelper {
  constructor() {
    this.BUTTON_STATE = true;
  }

  disable() {
    this.BUTTON_STATE = false;
  }

  enable() {
    this.BUTTON_STATE = true;
  }

  get state() {
    return this.BUTTON_STATE;
  }

  reset() {
    this.BUTTON_STATE = true;
  }
}

export const buyBonusButtonHelper = new BuyBonusButtonHelper();
